import React, { useState, useEffect, useMemo } from "react";
import { Button, Form } from "react-bootstrap";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import { card, colors, } from "../configs";
import Sarabun from '../assets/fonts/Sarabun/Sarabun-Regular.ttf';
import Bold from "../assets/fonts/Sarabun/Sarabun-Bold.ttf";
import Prompt from "../assets/fonts/Sarabun/Prompt-Bold.ttf";
import Loas from '../assets/fonts/Sarabun/NotoSansLao-Light.ttf'
import { db } from "../db/firestore";
import { Modal_Loading } from "../modal";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import bwipjs from 'bwip-js';
import { chunkArray } from "../Utility/function";

const { white, one } = colors;

const chunkSize = 2;

const MiniNoPro = (data) => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {chunkArray(data,45).map((item,index)=>{
            return <Page size="A4" key={index}  >
                    <View style={{ flexWrap:'wrap', flexDirection:'row'}} >
                        {item.map((a,i)=>{
                            const { name, unit, price, barcode, barcodeImage } = a;
                            return <View key={i} style={{width:"110px",alignItems:'center', borderWidth:0.5}} >
                                        <View style={{backgroundColor:'#eb9e34', width:'100%', height:"33px", justifyContent:'center', alignItems:'center' }} >
                                            <Text style={{ fontSize:9 }} numberOfLines={2} >{name}</Text>
                                        </View>
                                        <View style={{flexDirection:'row',alignItems:'flex-end', marginTop:-5, justifyContent:'space-around', width:'100%' }} >
                                            <Text style={{ fontSize:7 }}>({unit})</Text>
                                            <Text style={{ fontSize:28, marginBottom:-7, paddingBottom:0 }} >{price}</Text>
                                            <Text style={{ fontSize:10 }}>บาท</Text>
                                        </View>
                                        <Text style={{ fontSize:7 }} >{barcode}</Text>
                                        {barcodeImage && <Image style={{ width:'80px'}} src={barcodeImage} />}
                                    </View>
                        })}
                    </View>
                </Page>
        })}
      
    </Document>
);

  // Create Document Component
  const MiniWithPro = () => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {chunkArray(Array.from({ length:50 }),45).map((item,index)=>{

            return <Page size="A4" key={index}  >
                    <View style={{ flexWrap:'wrap', flexDirection:'row'}} >
                        {item.map((a,i)=>{
                            const { name, unit, price, promotion:{ qty, endDate, price:promotionPrice }, barcode, barcodeImage } = a;
                            const normalPrice = qty*price
                            
                            return <View key={i} style={{width:"110px",alignItems:'center', borderWidth:0.5}} >
                                        <View style={{backgroundColor:one, width:'100%', height:"27px", justifyContent:'center', alignItems:'center', color:white }} >
                                            <Text style={{ fontSize:15 }} numberOfLines={2} >ลดพิเศษ</Text>
                                        </View>
                                        <View style={{width:'100%', paddingLeft:10}} >
                                            <Text style={{ fontSize:8 }} numberOfLines={1}>{name}</Text>
                                            <Text style={{ fontSize:7 }}>{qty} {unit} ปกติราคา {normalPrice} บาท</Text>
                                        </View>
                                        <Text style={{ fontSize:20, color:one, marginTop:-10, marginBottom:-10 }}>{promotionPrice}</Text>
                                        <Text style={{ fontSize:7 }} >ราคานี้ จนถึง 24 กุมภา 2568</Text>
                                        <Text style={{ fontSize:5 }} >{barcode}</Text>
                                        {barcodeImage && <Image style={{ width:'50px'}} src={barcodeImage} />}
                                    </View>
                                    })}
                    </View>
                </Page>
        })}
      
    </Document>
);


const largeHorizontalNoPro = () => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {Array.from({ length:10 }).map((item,index)=>{
            const { name, unit, price, barcode, barcodeImage } = item;
            return <Page size="A4" orientation="landscape" key={index} >
                    <View style={{width:"100%",alignItems:'center', borderWidth:0.5}} >
                        <View style={{backgroundColor:'#de2702', width:'100%', justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, color:white }} >
                            <Text style={{ fontSize:65 }} numberOfLines={2} >{name}</Text>
                        </View>
                        <View style={{flexDirection:'row',alignItems:'flex-end', marginTop:-5, justifyContent:'space-around', width:'100%' }} >
                            <Text style={{ fontSize:35 }}>({unit})</Text>
                            <Text style={{ fontSize:200, marginBottom:-7, paddingBottom:0 }} >{price}</Text>
                            <Text style={{ fontSize:50 }}>บาท</Text>
                        </View>
                        <Text style={{ fontSize:30 }} >{barcode}</Text>
                        {barcodeImage && <Image style={{ width:'450px'}} src={barcodeImage} />}
                    </View>
                </Page>
        })}
      
    </Document>
);

const LargeHorizontalWithPro = () => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {Array.from({ length:10 }).map((item,index)=>{
            const { name, unit, price, promotion:{ qty, endDate, price:promotionPrice }, barcode, barcodeImage } = item;
            const normalPrice = qty*price
            const save = normalPrice - promotionPrice
            return <Page size="A4" orientation="landscape" key={index}  >
                    <View style={{width:"100%",alignItems:'center', borderWidth:0.5}} >
                        <View style={{backgroundColor:'#de2702', width:'100%', justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, color:white }} >
                            <Text style={{ fontSize:65 }} numberOfLines={2} >ลดพิเศษ</Text>
                        </View>
                        <View style={{width:'100%', paddingLeft:10}} >
                            <Text style={{ fontSize:35 }}>{name}</Text>
                            <Text style={{ fontSize:35 }}>{qty} {unit} ปกติราคา {normalPrice} บาท</Text>
                        </View>
                        <Text style={{ fontSize:200, marginBottom:-50, marginTop:-50, paddingBottom:0, color:one }} >{promotionPrice}</Text>
                        <Text style={{ fontSize:30, color:one }} >(ประหยัด {save.toFixed(2)} บาท)</Text>
                        <Text style={{ fontSize:30 }} >ราคานี้ จนถึง 24 กุมภา 2568</Text>
                        <Text style={{ fontSize:20 }} >{barcode}</Text>
                        {barcodeImage && <Image style={{ width:'450px'}} src={barcodeImage} />}
                    </View>
                </Page>
        })}
      
    </Document>
);

const LargeVerticalNoPro = () => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {Array.from({ length:10 }).map((item,index)=>{
            const { name, unit, price, barcode, barcodeImage } = item;
            return <Page size="A4" key={index}  >
                    <View style={{width:"100%",alignItems:'center', borderWidth:0.5}} >
                        <View style={{backgroundColor:'#de2702', width:'100%', justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, color:white, height:250 }} >
                            <Text style={{ fontSize:65 }} numberOfLines={2} >{name}</Text>
                        </View>
                        <Text style={{ fontSize:230,}} >{price}</Text>
                        <View style={{flexDirection:'row',alignItems:'flex-end', marginTop:-5, justifyContent:'space-around', width:'100%' }} >
                            <Text style={{ fontSize:35 }}>({unit})</Text>
                            <Text style={{ fontSize:50, marginBottom:70 }}>บาท</Text>
                        </View>
                        <Text style={{ fontSize:20 }} >{barcode}</Text>
                        {barcodeImage && <Image style={{ width:'500px'}} src={barcodeImage} />}
                    </View>
                </Page>
        })}
      
    </Document>
);

const LargeVerticalWithPro = () => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {Array.from({ length:10 }).map((item,index)=>{
            const { name, unit, price, barcode, barcodeImage, promotion:{ qty, endDate, price:promotionPrice }} = item;
            const normalPrice = qty*price;
            const save = normalPrice - promotionPrice;
            return <Page size="A4" key={index}  >
                    <View style={{width:"100%",alignItems:'center', borderWidth:0.5}} >
                        <View style={{backgroundColor:'#de2702', width:'100%', justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, color:white, height:250 }} >
                            <Text style={{ fontSize:150 }} numberOfLines={2} >ลดพิเศษ</Text>
                        </View>
                        <View style={{width:'100%', paddingLeft:10}} >
                            <Text style={{ fontSize:35 }}>{name}</Text>
                            <Text style={{ fontSize:35 }}>{qty} {unit} ปกติราคา {normalPrice} บาท</Text>
                        </View>
                        <Text style={{ fontSize:200, marginBottom:-50, marginTop:-50, paddingBottom:0, color:one }} >{promotionPrice}</Text>
                        <Text style={{ fontSize:30, color:one }} >(ประหยัด {save} บาท)</Text>
                        <Text style={{ fontSize:30, marginBottom:70 }} >ราคานี้ จนถึง 24 กุมภา 2568</Text>
                        <Text style={{ fontSize:20 }} >{barcode}</Text>
                        {barcodeImage && <Image style={{ width:'500px'}} src={barcodeImage} />}
                    </View>
                </Page>
        })}
      
    </Document>
);





function PriceTagScreen({ docId }) {
  const { language } = useSelector((state)=> state.device);
  const { currentUser } = useSelector( state => state.auth);
  const [shop, setShop] = useState({ name:'', id:''});
  const { name, yourCode } = shop;
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();


  const [tables, setTables] = useState([]);
  const [imageId, setImageId] = useState('');


  const [barcodeImage, setBarcodeImage] = useState('');

  useEffect(() => {
    // Generate the barcode
    try {
      const canvas = document.createElement('canvas');
      bwipjs.toCanvas(canvas, {
        bcid: 'code128', // Barcode type
        text: '123456789', // Barcode number
        scale: 3,
        height: 4,
        includetext: false, // We will add the text manually above the barcode
        textxalign: 'center',
      });

      setBarcodeImage(canvas.toDataURL('image/png')); // Convert to Base64
    } catch (err) {
      console.error('Error generating barcode:', err);
    }
  }, []);
  // const { fontFamily, imageBackground } = useMemo(()=>{
  //   return language.brev == 'lo'
  //           ?{ fontFamily:"NotoSansLao", imageBackground:card  }
  //           :{ fontFamily:"Prompt", imageBackground:card }
  // },[language,card])
  Font.register(
    {
      family: "Sarabun",
      src: Sarabun,
    },
    {
      family: "NotoSansLao",
      src: Loas,
    },
    {
      family: "Bold",
      src: Bold,
    },
    {
      family: "Prompt",
      src: Prompt,
    }
);
Font.register(
  {
    family: "Prompt",
    src: Prompt,
  }
);
  // Font.register({
  //   family: "NotoSansLao",
  //   src: Loas,
  // });
  // Font.register(

  //   {
  //     family: "Bold",
  //     src: Bold,
  //   }
  //   );

    // Font.register(

    //     {
    //       family: "Prompt",
    //       src: Prompt,
    //     }
    //     );

  // Create styles
const styles = StyleSheet.create({
    page: {
        fontFamily: "Sarabun",
        fontSize: 12,
        flexDirection: 'column',
        padding: 30,
        width:'1000px',
        height:'1500px'
      },
      section: {
        margin: 7,
        // padding: 10,
        // flex: 1,
        alignItems: 'center',
        // Gradient background
        // backgroundColor: '#da1b60',
        backgroundColor: 'red',
        height:'400px',
        width:'285px'
      },
      container: {
        width: '100%', height: '800vh' 
    },
  });


  // Create Document Component
const MyDocument = () => (
    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
        {chunkArray(Array.from({ length:50 }),45).map((item,index)=>{
            return <Page size="A4" key={index}  >
                    <View style={{ flexWrap:'wrap', flexDirection:'row'}} >
                        {item.map((a,i)=>{
                            return <View key={i} style={{width:"110px",alignItems:'center', borderWidth:0.5}} >
                                        <View style={{backgroundColor:one, width:'100%', height:"27px", justifyContent:'center', alignItems:'center', color:white }} >
                                            <Text style={{ fontSize:15 }} numberOfLines={2} >ลดพิเศษ</Text>
                                        </View>
                                        <View style={{width:'100%', paddingLeft:10}} >
                                            <Text style={{ fontSize:8 }} numberOfLines={1}>ยาสีฟันคอลเกต</Text>
                                            <Text style={{ fontSize:7 }}>10 หลอด ปกติราคา 130 บาท</Text>
                                        </View>
                                        <Text style={{ fontSize:20, color:one, marginTop:-10, marginBottom:-10 }}>99</Text>
                                        <Text style={{ fontSize:7 }} >ราคานี้ จนถึง 24 กุมภา 2568</Text>
                                        <Text style={{ fontSize:5 }} >ภ_ภถุภึถคึค</Text>
                                        {barcodeImage && <Image style={{ width:'50px'}} src={barcodeImage} />}
                                    </View>
                        })}
                    </View>
                </Page>
        })}
      
    </Document>
);


  return (
    <div style={{  height: '100vh', display: 'flex', flexDirection: 'column', justifyContent:'center', backgroundColor:white, width:'100vw' }}>
      <Modal_Loading show={loading} />
      {name
        ?<h1 style={{textAlign:'center'}} >{name}</h1>
        :null
      }
       <PDFViewer style={styles.container}>
        <MyDocument />
        </PDFViewer>
      {tables.length>0
          ?<>
            <div style={{ textAlign: 'center', marginTop: 10 }}>
              <PDFDownloadLink document={<MyDocument />} fileName={t('pdf.fileName',{ name })}>
              {/* <PDFDownloadLink document={<MyDocument />} fileName={`QRCode ติดโต๊ะแบบถาวร ${name}.pdf`}> */}
                {({ blob, url, loading, error }) =>
                  loading ? <Button style={{width:'300px',padding:30}} variant="secondary" >{t('pdf.loading')}</Button> : <Button style={{width:'300px',padding:30}} variant="success" >{t('pdf.download')}</Button>

                }
              </PDFDownloadLink>
            </div>
          </>
          :null
      };
  </div>
  );
};


export default PriceTagScreen;
